module.exports = __webpack_public_path__ + "img/sendTokens.80140aa9.svg";